import { render, staticRenderFns } from "./customNav.vue?vue&type=template&id=efa71d62&scoped=true"
import script from "./customNav.vue?vue&type=script&lang=js"
export * from "./customNav.vue?vue&type=script&lang=js"
import style0 from "./customNav.vue?vue&type=style&index=0&id=efa71d62&prod&lang=scss&scoped=true"
import style1 from "./customNav.vue?vue&type=style&index=1&id=efa71d62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa71d62",
  null
  
)

export default component.exports